<template>
  <div v-if="loading === false && cartPrizes" class="containerMembership">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet') && cartPrizes.length">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="back"/>
      <main>
        <b-row style="padding-bottom:100px;">

          <!-- prize card -->
          <b-col cols="12" style="margin:0px;padding:0px;" v-for="(prize, idxp) in cartPrizes" v-bind:key="idxp">
            <div class="prizeProductCardLine">
              <b-row align-v="center">
                <b-col cols="3" style="text-align:center;">
                  <img :src="getPrizeImagePath() + prize.photos[0].id" style="max-width: 40px; max-height: 40px;" />
                </b-col>
                <b-col cols="5" style="
                  font-style: normal;
                  font-weight: 300;
                  font-size: 14px;
                  letter-spacing: 0.25px;
                  color: #424242;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  <div style="max-height:40px;">
                    {{prize.name}}
                  </div>
                </b-col>
                <b-col cols="2" style="
                  font-style: normal;
                  font-weight: normal;
                  font-size: 12px;
                  letter-spacing: 0.15px;
                  color: #424242;
                  text-align:center;
                ">
                  {{prize.price_points}} pts.
                </b-col>
                <b-col cols="2" style="
                  margin-top:8px;
                  margin-bottom:8px;
                ">
                  <div @click="removeFromCart(prize.prize_id)" style="cursor:pointer;">
                    <font-awesome-icon style="font-size:18px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'trash']"/>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <!-- end card -->
          
        </b-row>
       <!--Carrinho de Prêmios

       {{$store.state.cartPrize.cart_prize_list}}
      <button v-if="$store.state.cartPrize.cart_prize_list" @click="checkoutOrder(cartPrize)">Concluir Resgate</button>
        -->
      </main>
      <footer style="position:relative;">
        <!-- fixed button action -->
        <b-row style="position:fixed;bottom:0px;width:100%;height:90px;background-color:#FFFFFF;">
          <div
          @click="finishCheckout()"
          :style="{backgroundColor: getCssColor('primary_bt')}"
          style="
          margin:21px auto;
            width:calc( 100% - 64px);height:48px;
            line-height:48px;
            border-radius:4px;
            text-align:center;
            font-style: normal;
            font-weight: 600;
            font-size: 15px;
            text-transform: uppercase;
            color: #FFFFFF;">CONCLUIR RESGATE</div>
        </b-row>
      </footer>
    </b-container>
    <b-container v-else>
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
      <main>
      <b-row align-h="center">
        <b-col cols="10" style="margin-top:100px;text-align:center;font-size:20px;line-height:30px;">
          Sua lista de resgates<br/>está vazia <font-awesome-icon style="color:#312922;line-height:24px;font-size:24px;opacity:0.74;" :icon="['fal', 'heart-broken']"/>
        </b-col>
      </b-row>
      </main>
      <footer style="position:relative;">
        <MembershipNavigation selected="claim"/>
      </footer>
    </b-container>
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import MembershipNavigation from '@/components/MembershipNavigation'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import MembershipConn from '@/connection/membership'
import membershipMixin from '@/mixins/membershipMixin'
import _ from 'lodash'
export default {
  data () {
    return {
      loading: true,
      cartPrizes: null
    }
  },
  mixins: [colors, membershipMixin],
  components: {InnerLoading, HeaderBackMobile, MembershipNavigation},

  mounted () {
    this.refreshPrizes()
  },

  methods: {
    

    async removeFromCart (id) {
      if (confirm('Deseja realmente remover o prêmio?')) {
        this.$store.state.showLoading = true
        await MembershipConn.removePrizetoCart(id) 
        this.refreshPrizes()
        this.$store.state.showLoading = false
      } 
    },

    async finishCheckout () {
      // TODO abrir endereços
     this.$router.push({path: '/membership_address'})

    },

    refreshPrizes () {
      if (this.$store.state.cartPrize.cart_prize_list.length) {
        let tempCartPrizes = _.clone(this.$store.state.cartPrize.cart_prize_list)
        this.cartPrizes = []
        tempCartPrizes.forEach( async (cartItem) => {
          let prize = await MembershipConn.getPrizeById(cartItem.prize_id)
          cartItem.name = prize.name
          cartItem.photos = prize.photos
          cartItem.price_points = prize.price_points
          this.cartPrizes.push(cartItem)
        })
      } else {
        this.cartPrizes = []
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.containerMembership {
  background-color: #FAFAFA;
  min-height: 100vh;
}

.prizeProductCardLine {
  padding:10px;
  background-color:#ffffff;
  border-bottom: 1px solid #D9D9D9;
  height:60px;
}


</style>
